module.exports = __webpack_public_path__ + "static/media/newsletter.5e8b76d9.jpg";